module.exports = __webpack_public_path__ + "static/media/4.6cc1e742.PNG";